<div class="d-flex">

  <div class="px-3 py-2" *ngIf="modelTab.descr">
    <p class="text-muted small mb-0">Model Description</p>
    <p class="mb-0 small">{{ modelTab.descr }}</p>
  </div>

  <div class="nav nav-links me-3 ms-auto">
    <jft-revision-model-settings-modal [modelTab]="modelTab" class="nav-item"></jft-revision-model-settings-modal>
  </div>

</div>
